import { memo } from "react";

import type { Stat } from "../RowStats";
import { PostAnswerCard } from "./PostAnswerCard";
import PostAnswerStats from "./PostAnswerStats";

type PostAnswerStatsBlockProps = {
	stats: Stat[];
};

export const PostAnswerStatsBlock = memo(
	({ stats }: PostAnswerStatsBlockProps) => {
		return (
			<PostAnswerCard>
				<PostAnswerStats stats={stats} />
			</PostAnswerCard>
		);
	},
);
